import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Scale, Users, HandHeart, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const FreeLegalAidSection = ({ t }) => {
  return (
    <section className="py-16 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-red-500 to-pink-600 rounded-full mb-4">
              <Heart className="h-8 w-8 text-white" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>
              {t.free_legal_aid_title || 'Free Legal Aid / Bonafide Cases'}
            </h2>
          </div>

          <Card className="bg-white shadow-xl border-2 border-amber-200">
            <CardContent className="pt-8 pb-8">
              <div className="text-center mb-6">
                <p className="text-lg text-gray-800 leading-relaxed mb-6">
                  {t.free_legal_aid_description || 'IP & Associates – Advocates is committed to providing free legal assistance to economically disadvantaged and underprivileged individuals. If you are unable to afford legal fees, we offer pro bono services for bonafide cases.'}
                </p>
                <p className="text-xl font-bold text-amber-700 italic">
                  {t.justice_quote || 'Justice should be accessible to everyone.'}
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-6 mt-8">
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-3">
                    <Scale className="h-6 w-6 text-blue-600" />
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">{t.pro_bono || 'Pro Bono Services'}</h3>
                  <p className="text-sm text-gray-600">{t.pro_bono_desc || 'Free legal representation for eligible cases'}</p>
                </div>
                
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 rounded-full mb-3">
                    <Users className="h-6 w-6 text-green-600" />
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">{t.underprivileged || 'For Underprivileged'}</h3>
                  <p className="text-sm text-gray-600">{t.underprivileged_desc || 'Supporting economically disadvantaged individuals'}</p>
                </div>
                
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-100 rounded-full mb-3">
                    <HandHeart className="h-6 w-6 text-purple-600" />
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">{t.bonafide_cases || 'Bonafide Cases'}</h3>
                  <p className="text-sm text-gray-600">{t.bonafide_cases_desc || 'Genuine cases with legal merit'}</p>
                </div>
              </div>

              <div className="mt-8 text-center">
                <p className="text-sm text-gray-600 italic mb-6">
                  {t.contact_for_aid || 'Contact us to discuss your case and eligibility for free legal aid.'}
                </p>
                <Link to="/bonafide-application">
                  <Button 
                    className="bg-gradient-to-r from-rose-600 to-pink-600 hover:from-rose-700 hover:to-pink-700 text-white px-8 py-6 text-lg"
                    data-testid="apply-bonafide-btn"
                  >
                    <Heart className="h-5 w-5 mr-2" />
                    {t.apply_bonafide || 'Apply for Free Legal Aid'}
                    <ArrowRight className="h-5 w-5 ml-2" />
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default FreeLegalAidSection;
